import { render, staticRenderFns } from "./JWL_Home.vue?vue&type=template&id=c6523e5a&lang=pug&"
import script from "./JWL_Home.vue?vue&type=script&lang=ts&"
export * from "./JWL_Home.vue?vue&type=script&lang=ts&"
import style0 from "./JWL_Home.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports